import { Component } from "@angular/core";
import { NavController, NavParams, ModalController, Events, AlertController } from "ionic-angular";
import { HttpClient } from "../../../../services/HttpClient";
import { CustomToast } from "../../../../util/CustomToast";

import { ImageSelector } from "../../../../util/imageSelector/imageSelector";

@Component({
  selector: "page-research-line",
  templateUrl: "researchLine.html",
  providers: [HttpClient, CustomToast],
})
export class ResearchLinePage {
  modalCtrl: ModalController;

  httpClient: HttpClient;
  baseUrl;

  researchline = {
    id: -1,
    name_es: "",
    name_en: "",
    description_es: "",
    description_en: "",
    image: "",
    coordinator_id: -1,
  };

  image = {
    id: -1,
    filename: "addimage.png",
  };

  customToast: CustomToast;
  events: Events;
  alertCtrl: AlertController;

  users;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    httpClient: HttpClient,
    customToast: CustomToast,
    modalCtrl: ModalController,
    events: Events,
    alertCtrl: AlertController
  ) {
    this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = navParams.get("id");
    this.httpCallResearchLine(id);

    this.httpPeopleByResearchLine(id);
  }

  httpCallResearchLine(id) {
    this.httpClient.get("/researchlines/" + id, (error, data) => {
      if (!error) {
        this.researchline = data.json();
        this.image.filename = this.researchline.image;
      }
    });
  }

  onClickSave() {
    this.httpUpdateResearchLine();
  }

  httpUpdateResearchLine() {
    this.httpClient.put("/researchlines", this.researchline, (error, data) => {
      if (!error) {
        this.customToast.showMessage("Departamento actualizado correctamente", 2000);
        this.navCtrl.pop();
        this.events.publish("researchLine:update");
      }
    });
  }

  httpPeopleByResearchLine(id) {
    this.httpClient.get("/users/research_line/" + id, (error, data) => {
      this.users = data.json();
    });
  }

  onClickImage() {
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss((image) => {
      if (image) {
        this.image = image;
        this.researchline.image = image.filename;
      }
    });
  }

  onClickDelete() {
    let alert = this.alertCtrl.create({
      title: "¿Estas seguro?",
      message: "Vas a eliminar la información de este departamento",
      buttons: [
        {
          text: "No",
          role: "cancel",
        },
        {
          text: "Si",
          role: "confirm",
          handler: () => {
            this.httpCallDelete();
          },
        },
      ],
    });
    alert.present();
  }

  httpCallDelete() {
    this.httpClient.delete("/researchlines/" + this.researchline.id, (error, data) => {
      if (!error) {
        this.customToast.showMessage("Departamento eliminado correctamente", 2000);
        this.navCtrl.pop();
        this.events.publish("researchLine:delete");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/researchLines/researchLine/researchLine.ts